



import EventListComponent from "@/components/admin/event/eventListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LiveListPage",
  components: {
    EventListComponent,
  },
})
export default class EventListPage extends Vue {}
